<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements"><br/><br/><br/><br/>
<p style="font-weight:bold;text-indent:17px;"><em>Contributors</em></p><br/>
<p style="text-indent:50px;">Nassim BARCHICHE. MD</p>
<p style="text-indent:80px;">Consultant Radiologist</p>
<p style="text-indent:80px;">Centre D’imagerie Médicale Dr. Lekhal M </p><p style="text-indent:80px;">Blida, Algeria</p><br/>
<p style="text-indent:50px;">Gamal HASSAN. MD, MRCP (UK)</p>
<p style="text-indent:80px;">Consultant Physician</p><p style="text-indent:80px;"> Ohud Hospital</p><p style="text-indent:80px;"> Medinah, KSA</p><br/>
<p style="text-indent:50px;">Chelia BOUKAABA. MD</p>
<p style="text-indent:80px;">Consultant Radiologist</p>
<p style="text-indent:80px;">Centre D’imagerie Médicale Aurès </p><p style="text-indent:80px;">Batna, Algeria</p><br/>
<p style="text-indent:50px;">Amine RAMDANI. MD</p>
<p style="text-indent:80px;">Consultant Radiologist</p>
<p style="text-indent:80px;">Centre D’imagerie Médicale Aurès Batna, Algeria</p><br/>
<p style="text-indent:50px;">Zine-eddine BOUDIAF. MD</p>
<p style="text-indent:80px;">Consultant Radiologist</p><p style="text-indent:80px;"> CHU Constantine, Algeria</p><br/>
<p style="text-indent:50px;">Fouzi BALA. MD</p>
<p style="text-indent:80px;">Consultant Interventional Neuro-radiologist </p><p style="text-indent:80px;">Roger Salengro Hospital</p>
<p style="text-indent:80px;">Lille, France</p><br/>
<p style="text-indent:50px;">Shahid HUSSEIN. MD </p><p style="text-indent:80px;">Consultant Radiologist</p><p style="text-indent:80px;"> Ohud Hospital Medinah, KSA</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?97e0e986